export default __webpack_public_path__ + "static/media/167.c184e2d8.gif";